import { createContext, useContext, type ComponentType, type ReactNode } from 'react'

export type LayoutChromeContextValue = {
  HeaderProfileArea?: ComponentType
}

const LayoutChromeContext = createContext<LayoutChromeContextValue>({})

export const LayoutChromeProvider = ({
  value,
  children
}: {
  value: LayoutChromeContextValue
  children: ReactNode
}) => (
  <LayoutChromeContext.Provider value={value}>
    {children}
  </LayoutChromeContext.Provider>
)

export const useLayoutChrome = () => useContext(LayoutChromeContext)
